export default __webpack_public_path__ + "83f2d3537c38372224e27a9cd994c6e5.png";